import Vue from 'vue'
import { PLAYBACK_API_TIMEOUT_MS } from './timeouts'

export default {
  apiPrefix: '/api/v2/sites',
  getSiteEdgePlaybacks: function ({siteId, targetRecordId}) {

    // OPTION 1 - limit total event to 50
    let query = `?limit=30`

    // OPTION 2 - to retrieve ONLY logs not yet retrieved
    if (targetRecordId) {
      query += `&sort=record_id&dir=desc`
      query += `&filter=record_id,${targetRecordId},lt`
    }
    else {
      // 테스트결과 logid로 sorting하는게 훨씬 속도가 빨라서 변경함.
      query += `&sort=record_id&dir=desc`
    }

    let apiDetailPath = this.apiPrefix + `/${siteId}/edge-playbacks${query}`
    return Vue.http.get(Vue.env.apiPath + apiDetailPath, Vue.auth.getBearerHeader(PLAYBACK_API_TIMEOUT_MS))
  },
  getDeviceEdgePlaybacks: function ({siteId, deviceId, targetRecordId}) {
    // OPTION 1 - limit total event to 50
    let query = `?limit=20`

    // OPTION 2 - to retrieve ONLY logs not yet retrieved
    if (targetRecordId) {
      query += `&sort=record_id&dir=desc`
      query += `&filter=record_id,${targetRecordId},lt`
    }
    else {
      // 테스트결과 logid로 sorting하는게 훨씬 속도가 빨라서 변경함.
      query += `&sort=record_id&dir=desc`
    }

    let apiDetailPath = this.apiPrefix + `/${siteId}/devices/${deviceId}/edge-playbacks${query}`
    return Vue.http.get(Vue.env.apiPath + apiDetailPath, Vue.auth.getBearerHeader(PLAYBACK_API_TIMEOUT_MS))
  },
  /**
   * 특정 edge playback 클립의 서명된 "재생(view)" URL을 발급받는다.
   *
   * CHEKT-1406에서 device-level 목록(getDeviceEdgePlaybacks) 응답의 `url` 필드가 제거되었다.
   * 따라서 클립을 재생하려면 이 엔드포인트로 record_id 단위 서명 URL을 받아야 한다.
   * 백엔드는 SITE_PARTITION_EDGE_PLAYBACK_READ 권한으로 게이팅하고 접근 이력(action=viewed)을 남긴다.
   *
   * @param {Object} params
   * @param {number|string} params.siteId   - 사이트 아이디
   * @param {number|string} params.deviceId - 카메라 디바이스 아이디 (클립 이벤트의 device_id)
   * @param {number|string} params.recordId - 재생할 클립의 record_id
   * @returns {Promise} vue-resource 응답 Promise (res.body = { url: string })
   */
  getEdgePlaybackViewUrl: function ({siteId, deviceId, recordId}) {
    let apiDetailPath = this.apiPrefix + `/${siteId}/devices/${deviceId}/edge_playback/view?record_id=${recordId}`
    return Vue.http.get(Vue.env.apiPath + apiDetailPath, Vue.auth.getBearerHeader(PLAYBACK_API_TIMEOUT_MS))
  },
  /**
   * 특정 edge playback 클립의 서명된 "다운로드(download)" URL을 발급받는다.
   *
   * view와 목적은 같지만 백엔드 권한과 접근 이력 액션이 다르다:
   *   - 권한: SITE_PARTITION_EDGE_PLAYBACK_DOWNLOAD_ACTION (view의 READ보다 상위, owner/admin)
   *   - 접근 이력: action=downloaded
   * 이 URL을 fetch → blob 변환하여 파일로 저장한다(호출부 downloadMedia).
   *
   * @param {Object} params
   * @param {number|string} params.siteId   - 사이트 아이디
   * @param {number|string} params.deviceId - 카메라 디바이스 아이디 (클립 이벤트의 device_id)
   * @param {number|string} params.recordId - 다운로드할 클립의 record_id
   * @returns {Promise} vue-resource 응답 Promise (res.body = { url: string })
   */
  getEdgePlaybackDownloadUrl: function ({siteId, deviceId, recordId}) {
    let apiDetailPath = this.apiPrefix + `/${siteId}/devices/${deviceId}/edge_playback/download?record_id=${recordId}`
    return Vue.http.get(Vue.env.apiPath + apiDetailPath, Vue.auth.getBearerHeader(PLAYBACK_API_TIMEOUT_MS))
  },
}